// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"ad2731c8","612":"9a9b2183","891":"fad64a26"}[chunkId] + ".chunk.js";
};